import { Component } from '@angular/core';
import {
  HeroPsicologiaSaludMentalComponent
} from "./hero-psicologia-salud-mental/hero-psicologia-salud-mental.component";
import {InfoComponent} from "../home/info/info.component";
import {ImportantPsicologiaComponent} from "./important-psicologia/important-psicologia.component";
import {FooterPersonaComponent} from "../../app-persona/footer-persona/footer-persona.component";

@Component({
  selector: 'app-psicologia-salud-mental',
  standalone: true,
    imports: [
        HeroPsicologiaSaludMentalComponent,
        InfoComponent,
        ImportantPsicologiaComponent,
        FooterPersonaComponent
    ],
  templateUrl: './psicologia-salud-mental.component.html',
  styleUrl: './psicologia-salud-mental.component.css'
})
export class PsicologiaSaludMentalComponent {


}
